(() => {
  document.addEventListener('scroll', () => {
    const storySections = document.querySelectorAll('.don-story-content__story');
    
    for (const section of storySections) {
      const sectionTopDistance = section.getBoundingClientRect().top;
      const activateOnDistance = 154;

      sectionTopDistance <= activateOnDistance
        ? section.classList.add('active')
        : section.classList.remove('active');
    }
  })
})();